import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserManagementPermissions } from '../enums/user-management-permissions.enum';

@Injectable({
	providedIn: 'root',
})
export class UsermanagementService {
	readonly url: string = 'usermanagement';

	constructor(private http: HttpClient) {}

	public loadEntities() {
		return this.http.get(`${this.url}/loadEntities/`);
	}

	public updateUserEntity(userId: number, updateValue: boolean, permissionType: UserManagementPermissions) {
		return this.http.get(`${this.url}/updateEntity/${userId}/${updateValue}/${permissionType}`);
	}

	public isUserOwnerOfCompany(companyId: number): Observable<boolean> {
		return this.http.get<boolean>(`${this.url}/isUserOwnerOfCompany/${companyId}`);
	}

	public getPermission(permissionId: number): Observable<boolean> {
		return this.http.get<boolean>(`${this.url}/getPermission/${permissionId}`);
	}
}
